import { render, staticRenderFns } from "./main-section-residents-current.vue?vue&type=template&id=75d0a2fe&scoped=true"
import script from "./main-section-residents-current.vue?vue&type=script&lang=js"
export * from "./main-section-residents-current.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d0a2fe",
  null
  
)

export default component.exports